import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function timesheetReducer(state = initialState.timesheets, action) {
    let newState = state;

    switch (action.type) {
        case types.APPROVE_TIMESHEET:
            if (action.status === 'success'){
                newState = editTimesheet(state, action.data, "APPROVED");
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.CM_LM_LOAD_TIMESHEETS_BY_WEEK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    cmlmTimesheets: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.DELETE_TIMESHEET:
            if (action.status === 'success'){
                newState = deleteTimesheet(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.EDIT_TIMESHEET_STATUS:
            if (action.status === 'success') {
                newState = editTimesheet(state, action.data.timesheet, action.data.status);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_TIMESHEETS_BY_USER_AND_WEEK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    currentTimesheet: action.data[0], //there will be just one timesheet, the current timesheet
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    currentTimesheet: null,
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_TIMESHEETS_BY_WEEK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    timesheets: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_LOAD_TIMESHEETS_BY_YEAR:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    timesheets: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_LOAD_TIMESHEETS_BY_RANGE:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    timesheets: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_LOADING_FLAG_FOR_TIMESHEET_STATE:
            return Object.assign({}, state, {
                loading: true
            });

        case types.SET_TIMESHEET_STATUS_TO_ENTRY:
            if (action.status === 'success'){
                newState = editTimesheet(state, action.data, "ENTRY");
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SUBMIT_TIMESHEET:
            if (action.status === 'success'){
                newState = editTimesheet(state, action.data, "SUBMITTED");
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        default:
            return state;
    }
}

function deleteTimesheet (state, data) {
    let timesheets = state.timesheets;
    let index = list.findIndexByID(timesheets, data);

    timesheets = list.remove(timesheets, index);

    return Object.assign({}, state, {
        loading: false,
        timesheets: timesheets
    });
}

function editTimesheet(state, timesheet, status) {

    timesheet.status = status;

    let newState = Object.assign({}, state, {
        currentTimesheet: timesheet,
        loading: false
    });
    return newState;
}

function rejectApprovedHours (state, timesheetID) {
        // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/timesheetReducer.js
 **/